module.exports = __webpack_public_path__ + "img/infrasel_5.2fd079fb.png";